export default "<p>security works!</p>\r\n";